/* eslint-disable eqeqeq */
import React from "react";
// PACKAGES
import { useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import {
  Modal,
  Backdrop,
  Fade,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { grey } from "@mui/material/colors";

// ACTIONS
import AddCredFuncionario from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/AddCredFuncionarioAction";
import EditCredFuncionario from "../../../../../utils/redux/actions/aprovisionamento/credenciacoes/EditCredFuncionarioAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "none",
  borderRadius: 2,
  boxShadow: 3,
  p: 3,
};

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: '2px solid #000',
    borderRadius: "10px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3, 6, 5),
    maxWidth: "800px",
    width: "800px",
    margin: 15,
  },
  btnConfirmar: {
    color: "white",
    backgroundColor: "#E21450",
    width: "auto",
    height: "40px",
    fontWeight: "bold",
  },
  btnConfirmarLoading: {
    width: "auto",
    height: "40px",
    backgroundColor: grey[300],
  },
  btnCancelar: {
    color: "#E21450",
    width: "auto",
    height: "40px",
    fontWeight: "bold",
    // borderRadius: '15px',
    backgroundColor: "white",
    border: `1px solid #707070`,
    display: "flex",
    alignItems: "center",
    transition: "0.2s",
    "&:hover": {
      backgroundColor: "#ECECEC",
      border: "1px solid #707070",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "#F7F7F7 ",
      },
    },
  },
  modalBtns: {
    display: "flex",
    width: "100%",
    marginTop: "20px",
    justifyContent: "space-evenly",
  },
}));

const ModalRascunho = ({
  openRascunho,
  handleClose,
  fetchCredFuncionarios,
  dados,
  // Loading
  loading,
  setLoading,
  loadingRascunho,
  setLoadingRascunho,
  aeroporto,
  ficheiros,
  evidencias,
  evidenciasNomes,
  removeEvList,
  datePickerValues,
  toggleDrawer,
  ShowNotification,
  modalState,
  idElem,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // ############################################################## //
  // ################  Handle Submit and Messages  ################# //
  // ############################################################## //

  const warningMessage = {
    isOpen: true,
    message: "Foi guardado um rascunho de um colaborador",
    type: "warning",
  };
  const message = {
    isOpen: true,
    message: "Colaborador adicionado com sucesso!!",
    type: "success",
  };

  const handleGuardar = (e) => {
    e.preventDefault();
    setLoading(true);
    dados[0] = { ...dados[0], rascunho: 0 };
    if (modalState == "add") {
      dispatch(
        AddCredFuncionario(
          dados,
          aeroporto,
          ficheiros,
          evidencias,
          evidenciasNomes,
          datePickerValues,
          toggleDrawer,
          ShowNotification
        )
      )
        .then(() => {
          handleClose(e);
          toggleDrawer("right", false);
          dispatch(ShowNotification(message));
        })
        .then(() => fetchCredFuncionarios());
    }

    if (modalState == "edit") {
      dispatch(
        EditCredFuncionario(
          dados,
          aeroporto,
          idElem,
          ficheiros,
          evidencias,
          evidenciasNomes,
          removeEvList,
          datePickerValues,
          toggleDrawer,
          ShowNotification
        )
      )
        .then(() => {
          handleClose(e);
          toggleDrawer("right", false);
          dispatch(ShowNotification(message));
        })
        .then(() => fetchCredFuncionarios());
    }
  };

  const handleGuardarRascunho = (e) => {
    e.preventDefault();
    setLoadingRascunho(true);
    dados[0] = { ...dados[0], rascunho: 1 };
    if (modalState == "add") {
      dispatch(
        AddCredFuncionario(
          dados,
          aeroporto,
          ficheiros,
          evidencias,
          evidenciasNomes,
          datePickerValues,
          toggleDrawer,
          ShowNotification
        )
      )
        .then(() => {
          handleClose(e);
          toggleDrawer("right", false);
          dispatch(ShowNotification(warningMessage));
        })
        .then(() => fetchCredFuncionarios());
    }

    if (modalState == "edit") {
      dispatch(
        EditCredFuncionario(
          dados,
          aeroporto,
          idElem,
          ficheiros,
          evidencias,
          evidenciasNomes,
          removeEvList,
          datePickerValues,
          toggleDrawer,
          ShowNotification
        )
      )
        .then(() => {
          handleClose(e);
          toggleDrawer("right", false);
          dispatch(ShowNotification(warningMessage));
        })
        .then(() => fetchCredFuncionarios());
    }
  };

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openRascunho}
        onClose={(e) => handleClose(e)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openRascunho}>
          <Box sx={style}>
            <div className="header-modal">
              <h3
                id="transition-modal-title"
                style={{ fontSize: "20px", textAlign: "center" }}
              >
                Campos Obrigatórios não Preenchidos
              </h3>
              <p
                id="transition-modal-description"
                style={{ textAlign: "center" }}
              >
                Não tem os campos obrigatórios preenchidos. O que pretende
                fazer?
              </p>
            </div>
            <div className={classes.modalBtns}>
              <Button
                className={
                  loading ? classes.btnConfirmarLoading : classes.btnConfirmar
                }
                disabled={!!loading}
                variant="contained"
                onClick={handleGuardar}
                sx={{ mx: 1 }}
              >
                {loading && (
                  <CircularProgress
                    size={14}
                    style={{ color: "#9d9d9d", marginRight: "10px" }}
                  />
                )}
                Submeter
              </Button>
              <Button
                className={
                  loadingRascunho
                    ? classes.btnConfirmarLoading
                    : classes.btnCancelar
                }
                disabled={!!loadingRascunho}
                variant="contained"
                onClick={handleGuardarRascunho}
                sx={{ mx: 1 }}
              >
                {loadingRascunho && (
                  <CircularProgress
                    size={14}
                    style={{ color: "#9d9d9d", marginRight: "10px" }}
                  />
                )}
                Guardar como rascunho
              </Button>
              <Button
                className={classes.btnCancelar}
                variant="contained"
                onClick={(e) => handleClose(e)}
                sx={{ mx: 1 }}
              >
                Cancelar
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default ModalRascunho;
